import { Flex, Text, Card } from "@radix-ui/themes";

export function ChartCard({ text, children, legend }) {
  return (
    <Card size="2" style={{ display: "flex", height: "248px", width: "100%", flexDirection: "column",
      gap: "var(--space-2)" }}>  
      <Flex className="title-and-icon-button" display="inline-flex" direction="row" align="center" justify="between">
        <Text as="span" size="2" weight="medium" color="gray">{text}</Text>
        <Flex display="inline-flex" align="center" gap="16px">{legend}</Flex>
      </Flex>
      <Flex height="188px">{children}</Flex>
    </Card>
  )
}
